import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface CommentsRequest {
  passportId: string;
  header: any;
  readOnly?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CommentsPanelService {
  private readonly openCommentsSubject = new Subject<CommentsRequest>();
  
  openComments$ = this.openCommentsSubject.asObservable();

  openCommentsPanel(passportId: string, header: any, readOnly = false): void {
    this.openCommentsSubject.next({ passportId, header, readOnly });
  }
}

